/** «Помощь»: plain answers about the bot, money and protection, with search. */
import { ChevronDown, ChevronRight, Search } from "lucide-react";
import { useState } from "react";
import { useLocation } from "react-router";

import { Button } from "@/design-system/Button";
import { PageHeader } from "@/design-system/PageHeader";
import { Panel } from "@/design-system/Panel";

import { SECTIONS, search, type Article } from "./articles";

function Entry({ article, forced }: { readonly article: Article; readonly forced: boolean }): React.JSX.Element {
  const [open, setOpen] = useState(false);
  // A search or a link to the article keeps it open; otherwise the reader opens it.
  const shown = open || forced;
  return (
    <li id={article.id} className="border-b border-border-subtle last:border-b-0" data-testid="help-article">
      <Button
        type="button"
        variant="ghost"
        aria-expanded={shown}
        onClick={() => { setOpen(!shown); }}
        className="h-auto w-full justify-start gap-2 py-3 text-left text-body-main font-medium text-text-primary"
      >
        {shown ? <ChevronDown aria-hidden="true" className="size-4 shrink-0" /> : <ChevronRight aria-hidden="true" className="size-4 shrink-0" />}
        {article.title}
      </Button>
      {shown && (
        <div className="flex flex-col gap-2 pb-4 pl-6 text-body-main text-text-secondary">
          {article.body.map((paragraph) => <p key={paragraph.slice(0, 40)}>{paragraph}</p>)}
        </div>
      )}
    </li>
  );
}

export function HelpPage(): React.JSX.Element {
  const [query, setQuery] = useState("");
  const anchor = useLocation().hash.slice(1);
  const found = search(query);
  return (
    <div className="flex max-w-3xl flex-col gap-2" data-testid="help">
      <PageHeader title="Помощь" description="Как работает бот, комиссия и защита счёта — простыми словами." />
      <label className="flex items-center gap-2 rounded-row border border-border-strong bg-surface-default px-3 focus-within:outline-2 focus-within:outline-focus-ring">
        <Search aria-hidden="true" className="size-4 text-text-muted" />
        <input
          aria-label="Поиск по помощи"
          placeholder="Например: комиссия, делистинг, трейлинг"
          className="min-h-11 w-full bg-transparent text-body-main text-text-primary outline-none"
          value={query}
          onChange={(event) => { setQuery(event.target.value); }}
        />
      </label>
      {found.length === 0 && <Panel><p className="text-body-main text-text-secondary">Ничего не нашлось. Попробуйте другое слово или напишите нам в Telegram.</p></Panel>}
      {SECTIONS.map((section) => {
        const articles = found.filter((article) => article.section === section);
        if (articles.length === 0) return null;
        return (
          <Panel key={section} title={section}>
            <ul>
              {articles.map((article) => (
                <Entry key={article.id} article={article} forced={article.id === anchor || query !== ""} />
              ))}
            </ul>
          </Panel>
        );
      })}
    </div>
  );
}
